export const meetingsEndpoint = {
  delete: '/api/Meeting/Delete',
  getById: '/api/Meeting/',
  getMeetingAvailabilty: '/api/Meeting/MeetingAvailabilty',
  getType: '/api/Meeting/Type',
  getPriority: '/api/Meeting/Priority',
  getIntended: '/api/Meeting/Intended',
  getStatus: '/api/Meeting/Status',
  getMemberType: '/api/Meeting/MemberType',
  getTimeZones: '/api/Meeting/TimeZones',
  getTokenCreation: '/api/Meeting/TokenCreation',
  postGetAll: '/api/Meeting/GetAll',
  postInsert: '/api/Meeting/Insert',
  postFilter: '/api/Meeting/Filter',
  postNewFilter: '/api/Meeting/NewFilter',
  putUpdate: '/api/Meeting/Update',
  putChangeStatus: '/api/Meeting/ChangeStatus',
  postUploadAttachment: '/api/MeetingFile/Upload',
  deleteAttachment: '/api/MeetingFile/Delete',
  clearAttachment: '/api/MeetingFile/ClearFiles', 
  postMinutesOfMeeting:'/api/MinuteOfMeeting/Insert',
};